export class CentersExplorator extends HTMLDivElement {
    //private departments = ['22', '29', '35', '56'];

    private ccitIds = ['1', '3', '4', '5','7'];
    private accordionButtons: Map<string, HTMLElement> = new Map();
    private svgGroups: Map<string, SVGElement> = new Map();

    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }

    private init() {

        // Récupérer les boutons d'accordéon
        const buttons = this.querySelectorAll('[data-dept]');
        buttons.forEach(button => {
            const dept = button.getAttribute('data-dept');
            if (dept) {
                this.accordionButtons.set(dept, button as HTMLElement);
                
                // Écouter les événements de l'accordéon
                button.addEventListener('mouseenter', () => this.hoverDept(dept));
                button.addEventListener('focus', () => this.hoverDept(dept));
                button.addEventListener('mouseleave', () => this.unhoverDeptIfClosed(dept));
                button.addEventListener('blur', () => this.unhoverDeptIfClosed(dept));
            }
        });

        // Récupérer les groupes SVG
        const svg = this.querySelector('svg.map');
        if (svg) {
            this.ccitIds.forEach(dept => {
                const group = svg.querySelector(`#group-${dept}`) as SVGElement;
                if (group) {
                    this.svgGroups.set(dept, group);
                    
                    // Ajouter l'event listener pour le clic sur le groupe
                    group.addEventListener('click', () => this.openAccordion(dept));
                    
                    // Hover sur le SVG
                    group.addEventListener('mouseenter', () => this.hoverDept(dept));
                    group.addEventListener('mouseleave', () => this.unhoverDeptIfClosed(dept));
                }
            });
        }

        // Écouter les changements d'état de l'accordéon (Bootstrap)
        this.observeAccordionState();
    }

    private hoverDept(dept: string) {
        const group = this.svgGroups.get(dept);
        if (group) {
            group.classList.add('hover');
        }
    }

    private unhoverDeptIfClosed(dept: string) {
        const button = this.accordionButtons.get(dept);
        if (button && !this.isAccordionItemOpen(button)) {
            const group = this.svgGroups.get(dept);
            if (group) {
                group.classList.remove('hover');
            }
        }
    }

    private activateDept(dept: string) {

        const group = this.svgGroups.get(dept);
        if (group) {
            group.classList.add('active');
            group.classList.remove('hover');
        }
    }

    private deactivateDept(dept: string) {
        const group = this.svgGroups.get(dept);
        if (group) {
            group.classList.remove('active');
            group.classList.remove('hover');
        }
    }

    private openAccordion(dept: string) {
        const button = this.accordionButtons.get(dept);
        if (button && !this.isAccordionItemOpen(button)) {
            // Simuler un clic sur le bouton pour ouvrir l'accordéon
            button.click();
        }
    }

    private isAccordionItemOpen(button: HTMLElement): boolean {
        return !button.classList.contains('collapsed');
    }

    private observeAccordionState() {
        // Observer les changements de classe "collapsed" sur les boutons
        const buttons = this.querySelectorAll('[data-dept]');
        buttons.forEach(button => {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach(mutation => {
                    if (mutation.attributeName === 'class') {
                        const dept = button.getAttribute('data-dept');
                        if (dept) {
                            if (this.isAccordionItemOpen(button as HTMLElement)) {
                                this.activateDept(dept);
                            } else {
                                this.deactivateDept(dept);
                            }
                        }
                    }
                });
            });

            observer.observe(button, { attributes: true, attributeFilter: ['class'] });
        });
    }

}
